export default {
  div: null,
  interval: null,
  size: {
    height: 80,
    width: 80
  },
  images: {
    open: '/assets/images/skydiver-open.webp',
    closed: '/assets/images/skydiver-closed.webp'
  },
  preload() {
    for (const prop in this.images) {
      const img = new Image()
      img.src = this.images[prop]
    }
  },
  jump(originX, originY) {
    if(this.div) {
      this.div.remove()
    }
    clearInterval(this.interval)

    this.div = document.createElement('div')
    this.div.style.position = 'absolute'
    this.div.style.height = `${this.size.height}px`
    this.div.style.width = `${this.size.width}px`
    this.div.style.left = `${originX}px`
    this.div.style.top = `${originY}px`
    this.div.style.zIndex = 100
    this.div.style.backgroundImage = `url('${this.images.closed}')`
    this.div.style.backgroundSize = 'cover'

    document.body.appendChild(this.div)

    const distanceToFall = document.documentElement.scrollHeight - originY - this.size.height

    let traveled = 0;
    let positionY = originY;
    this.interval = setInterval(() => {
      //fall 100px fast
      if(traveled < 100) {
        traveled++
        positionY++
        this.div.style.top = `${positionY}px`
      } else {
        //fall the rest of the distance slower and sway.
        clearInterval(this.interval)
        this.div.classList.add('skydive-sway')
        this.div.style.backgroundImage = `url('${this.images.open}')`
        this.interval = setInterval(() => {
          traveled++
          positionY++
          if(traveled >= distanceToFall) {
            clearInterval(this.interval)
            this.div.remove()
          }

          this.div.style.top = `${positionY}px`
        }, 10)
      }
    }, 5)
  }
}
